import React from 'react'
import { Fragment } from 'react'
import UserAccessRouteData from '../components/UserAccessRoute/UserRoute'

function UserAccessRoute() {
  return (
    <Fragment>
        <UserAccessRouteData/>
    </Fragment>
  )
}

export default UserAccessRoute